import { DashboardHeader } from "@/components/dashboard-header";
import { ErrorState } from "@/components/reusable-components/error-state";
import { SidebarInset } from "@/components/ui/sidebar";

const DESCRIPTION = (
  <>
    The page you're looking for doesn't exist <br /> or may have been moved.
  </>
);

/** Full-screen 404, used by the root route for unmatched URLs. */
export const NotFound = () => (
  <ErrorState code="404" title="Page Not Found" description={DESCRIPTION} />
);

/**
 * 404 for a bad URL under a role layout — renders in the content area so the
 * sidebar stays available instead of the whole screen being replaced.
 */
export const NotFoundInLayout = () => (
  <SidebarInset>
    <DashboardHeader breadcrumbs={[{ label: "Page Not Found" }]} />
    <ErrorState
      code="404"
      title="Page Not Found"
      description={DESCRIPTION}
      fullScreen={false}
    />
  </SidebarInset>
);

export default NotFound;
